import { useCallback } from 'react';
import Images from 'src/App/Images';
import AvatarFallback from 'src/App/Images/avatarFallback.svg';
import { ILeaderboardUser } from 'src/App/Types/leader.types';
import { LeaderboardItemContain, LIAvatarContainer, LIBitsContainer, LIList, LIListHeader, LIListItem, LIRankContainer, LIUserContainer, LIUserNameContainer } from './LeaderboardItem.styles';

export function LeaderboardUserItem({ users }: { users: ILeaderboardUser[] }) {
	const handleAvatarFallbackImg = useCallback((e: any) => {
		e.target.src = AvatarFallback;
	}, []);

	const renderRankImgs = useCallback((idx) => {
		if (idx == 1) {
			return <Images.FirstPlace />;
		} else if (idx == 2) {
			return <Images.SecondPlace />;
		} else if (idx == 3) {
			return <Images.ThirdPlace />;
		} else {
			return idx;
		}
	}, []);

	return (
		<LeaderboardItemContain>
			<LIListHeader>
				<div>Rank</div>
				<div>Name</div>
				<div style={{ minWidth: '40px' }}>Bits</div>
			</LIListHeader>
			<LIList>
				{users.map((user, idx) => (
					<LIListItem key={user.name + user.username}>
						<LIRankContainer>{renderRankImgs(idx + 1)}</LIRankContainer>
						<LIUserContainer>
							<LIAvatarContainer>{user.avatar ? <img src={user.avatar} onError={handleAvatarFallbackImg} /> : <Images.AvatarFallback />}</LIAvatarContainer>
							<LIUserNameContainer>{user.username || user.user_id}</LIUserNameContainer>
						</LIUserContainer>
						<LIBitsContainer>{user.bits}</LIBitsContainer>
					</LIListItem>
				))}
			</LIList>
		</LeaderboardItemContain>
	);
}
